import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { injectIntl, defineMessages } from "react-intl";

import { Message } from "semantic-ui-react";
import {
  ReduxFormMaterialTextField,
  ReduxFormMaterialSelect,
  ReduxFormMaterialSwitch,
  Loading,
  Button,
} from "components";

import * as commonVar from "libs/commonVar";
import * as common from "libs/commonFunc";

import classNames from "classnames/bind";
import styles from "./UserEdit.css";
const cx = classNames.bind(styles);

class UserEdit extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // 모달의 onOpen 이벤트 대용
    const { handleOnOpenEditModal } = this.props;

    handleOnOpenEditModal();
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      addMode,
      isAuth,
      onProgress,
      errorMessage,
      userInfo,
      handleUserEmailReSend,
      handleUserEmailCancel,
    } = this.props;
    const { userNo, userNewEmail, passwdUpdateEpoch, regEpoch } = userInfo;

    let emailHelperText = "";
    if (isAuth !== 2 && !userNewEmail) {
      emailHelperText = defineMessages(
        formatMessage({
          id: "UserEdit_6",
          defaultMessage:
            "수정된 이메일은 별도의 확인 메일 승인 후 반영됩니다.",
        })
      );

      if (!!errorMessage) {
        emailHelperText = "";
      }
    }

    return (
      <div className={cx("template-edit-box")}>
        <Loading
          active={onProgress}
          size="small"
          content={defineMessages(
            formatMessage({ id: "UserEdit_1", defaultMessage: "처리 중..." })
          )}
        />
        <div className={cx("template-edit-section")}>
          <span className={cx("materialTextField-title")}>
            {defineMessages(
              formatMessage({ id: "UserEdit_4", defaultMessage: "이름" })
            )}
          </span>
          <ReduxFormMaterialTextField
            className={cx("input-gap", "input-area")}
            required
            fullWidth
            // label={defineMessages(formatMessage({ id: 'UserEdit_4', defaultMessage: '이름' }))}
            name="userName"
            checkType={101}
            validate={["required", "userName"]}
          />
          <span className={cx("materialTextField-title")}>
            {defineMessages(
              formatMessage({ id: "UserEdit_5", defaultMessage: "이메일" })
            )}
          </span>
          <ReduxFormMaterialTextField
            className={cx("input-gap", "input-area", "change-email-text")}
            required
            fullWidth
            // label={defineMessages(formatMessage({ id: 'UserEdit_5', defaultMessage: '이메일' }))}
            helperText={emailHelperText}
            errorText={errorMessage}
            name="userEmail"
            checkType={101}
            validate={["required", "email"]}
            error={!!errorMessage}
            // warn={['email']}
          />
          {!!userNewEmail && (
            <div className={cx("change-email")}>
              <div className={cx("change-email-message")}>
                {defineMessages(
                  formatMessage({ id: "UserEdit_7", defaultMessage: "현재" })
                ) +
                  " '" +
                  userNewEmail +
                  "'" +
                  defineMessages(
                    formatMessage({
                      id: "UserEdit_8",
                      defaultMessage: "이 승인 대기중입니다.",
                    })
                  )}
              </div>
              <Button
                className={cx("bt-style-gleam")}
                onClick={handleUserEmailReSend}
              >
                {defineMessages(
                  formatMessage({
                    id: "CheckEmailResult_6",
                    defaultMessage: "재전송",
                  })
                )}
              </Button>
              <Button
                className={cx("bt-style-gleam bt-red")}
                onClick={handleUserEmailCancel}
              >
                {defineMessages(
                  formatMessage({
                    id: "ModalEditPassword_3",
                    defaultMessage: "취소",
                  })
                )}
              </Button>
            </div>
          )}
          {/* autocomplete 되는 것을 방지하기 위해 input 추가 */}
          {isAuth === 2 && (
            <input className="display-none" type="password" name="userPasswd" />
          )}
          {isAuth === 2 && (
            <div>
              <span className={cx("materialTextField-title")}>
                {defineMessages(
                  formatMessage({
                    id: "UserEdit_9",
                    defaultMessage: "비밀번호",
                  })
                )}
              </span>
              <ReduxFormMaterialTextField
                className={cx("input-gap", "input-area", "user-password")}
                type="password"
                required
                inputProps={{
                  autoComplete: "user-password",
                  autoCorrect: "off",
                }}
                fullWidth
                // label={defineMessages(formatMessage({ id: 'UserEdit_9', defaultMessage: '비밀번호' }))}
                name="userPasswd"
                checkType={101}
                validate={["required", "gsPassword"]}
              />
            </div>
          )}
          <span className={cx("materialTextField-title")}>
            {defineMessages(
              formatMessage({ id: "UserEdit_10", defaultMessage: "연락처" })
            )}
          </span>
          <ReduxFormMaterialTextField
            className={cx("input-gap", "input-area")}
            fullWidth
            // label={defineMessages(formatMessage({ id: 'UserEdit_10', defaultMessage: '연락처' }))}
            name="userPhone"
            checkType={101}
            validate={["userPhone", "maxLength20"]}
          />
          {!addMode && (
            <div>
              <span className={cx("materialTextField-title")}>
                {defineMessages(
                  formatMessage({
                    id: "UserEdit_27",
                    defaultMessage: "서비스No",
                  })
                )}
              </span>
              <ReduxFormMaterialTextField
                className={cx("input-gap", "input-area")}
                required
                fullWidth
                disabled
                // label={defineMessages(formatMessage({ id: 'UserEdit_11', defaultMessage: '서비스명' }))}
                name="serviceNo"
                checkType={101}
              />
            </div>
          )}
          <span className={cx("materialTextField-title")}>
            {defineMessages(
              formatMessage({ id: "UserEdit_11", defaultMessage: "서비스명" })
            )}
          </span>
          <ReduxFormMaterialTextField
            className={cx("input-gap", "input-area")}
            required
            fullWidth
            // label={defineMessages(formatMessage({ id: 'UserEdit_11', defaultMessage: '서비스명' }))}
            name="serviceName"
            checkType={101}
            validate={["required", "serviceName"]}
          />
          {/* 최근 비밀번호 수정일 */}
          {/* {!addMode && (
            <div className={cx('userEdit-infoRow')}>
              <div>{defineMessages(formatMessage({ id: 'UserEdit_23', defaultMessage: '최근 비밀번호 수정일' }))}</div>
              <div className={cx('row-content')}>{common.timeFormatFromUTCEpoch(passwdUpdateEpoch, 1)}</div>
            </div>
          )} */}
          {/* 서비스 가입일 */}
          {/* {!addMode && (
            <div className={cx('userEdit-infoRow')}>
              <div>{defineMessages(formatMessage({ id: 'UserEdit_24', defaultMessage: '서비스 가입일' }))}</div>
              <div className={cx('row-content')}>{common.timeFormatFromUTCEpoch(regEpoch, 1)}</div>
            </div>
          )} */}
        </div>
        {isAuth === 2 && (
          <div className={cx("template-edit-section")}>
            <div className={cx("input-title")}>
              {defineMessages(
                formatMessage({
                  id: "UserEdit_12",
                  defaultMessage: "관리자 메뉴",
                })
              )}
            </div>
            <div className={cx("flex-row-flex-start", "input-gap")}>
              <div className={cx("half-line")}>
                <span className={cx("materialTextField-title")}>
                  {defineMessages(
                    formatMessage({
                      id: "UserEdit_13",
                      defaultMessage: "계정 활성화",
                    })
                  )}
                </span>
                <div className={cx("input-area-mt")}>
                  <ReduxFormMaterialSelect
                    required
                    name="userActived"
                    className={cx(
                      "list-target",
                      "input-flex",
                      "input-area",
                      "select-input"
                    )}
                    fullWidth
                    menuList={[
                      {
                        key: 1,
                        value: 1,
                        text: defineMessages(
                          formatMessage({
                            id: "UserEdit_14",
                            defaultMessage: "정상",
                          })
                        ),
                      },
                      {
                        key: 0,
                        value: 0,
                        text: defineMessages(
                          formatMessage({
                            id: "UserEdit_15",
                            defaultMessage: "비활성",
                          })
                        ),
                      },
                    ]}
                    defaultValue={1}
                    checkType={101}
                    validate={["required"]}
                  />
                </div>
              </div>
              {/* <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div> */}
              {/* <ReduxFormMaterialSelect
                required
                label={defineMessages(formatMessage({ id: 'UserEdit_16', defaultMessage: '계정 잠김' }))}
                name="userStatus"
                className={cx('list-target', 'input-flex')}
                fullWidth
                menuList={[
                  {
                    key: 0,
                    value: 0,
                    text: defineMessages(formatMessage({ id: 'UserEdit_14', defaultMessage: '정상' }))
                  },
                  {
                    key: 1,
                    value: 1,
                    text: defineMessages(formatMessage({ id: 'UserEdit_17', defaultMessage: '잠김' }))
                  }
                ]}
                defaultValue={0}
                checkType={101}
                validate={['required']}
              /> */}
              {!addMode && <div>&nbsp;&nbsp;&nbsp;</div>}
              {!addMode && (
                <div className={cx("userEnabled-wrap")}>
                  <span className={cx("materialTextField-title")}>
                    {defineMessages(
                      formatMessage({
                        id: "UserEdit_18",
                        defaultMessage: "계정 삭제",
                      })
                    )}
                  </span>
                  <div className={cx("input-area-mt")}>
                    <ReduxFormMaterialSelect
                      required
                      name="userEnabled"
                      className={cx(
                        "list-target",
                        "input-flex",
                        "input-area",
                        "select-input"
                      )}
                      fullWidth
                      menuList={[
                        {
                          key: 1,
                          value: 1,
                          text: defineMessages(
                            formatMessage({
                              id: "UserEdit_14",
                              defaultMessage: "정상",
                            })
                          ),
                        },
                        {
                          key: 0,
                          value: 0,
                          text: defineMessages(
                            formatMessage({
                              id: "UserEdit_19",
                              defaultMessage: "삭제",
                            })
                          ),
                        },
                      ]}
                      defaultValue={0}
                      checkType={101}
                      validate={["required"]}
                    />
                  </div>
                </div>
              )}
            </div>
            {!addMode && (
              <div>
                <span className={cx("materialTextField-title")}>
                  {defineMessages(
                    formatMessage({
                      id: "UserEdit_20",
                      defaultMessage: "로그인 실패 횟수",
                    })
                  )}
                </span>
                <ReduxFormMaterialTextField
                  className={cx("input-gap", "input-area")}
                  required
                  fullWidth
                  // label={defineMessages(formatMessage({ id: 'UserEdit_20', defaultMessage: '로그인 실패 횟수' }))}
                  name="loginFailCount"
                  defaultValue={"0"}
                  checkType={101}
                  validate={["required", "number", "maxValue50"]}
                />
              </div>
            )}
            {commonVar.isGs !== 1 && !addMode && (
              <div className={cx("input-area-mt")}>
                <ReduxFormMaterialSwitch
                  className={cx("input-switch", "mbt-15", "select-input")}
                  label={defineMessages(
                    formatMessage({
                      id: "UserEdit_21",
                      defaultMessage: "최근 비밀번호 수정일을 현재로 변경",
                    })
                  )}
                  name="passwdUpdateDateNow"
                  checkType={101}
                />
              </div>
            )}
            {/* 교육 활성화 */}
            {commonVar.isEdu === 1 && (
              <div className={cx("half-line", "isEdu-wrap")}>
                <span className={cx("materialTextField-title")}>
                  {defineMessages(
                    formatMessage({
                      id: "UserEdit_25",
                      defaultMessage: "교육관리 사용",
                    })
                  )}
                </span>
                <div className={cx("input-area-mt")}>
                  <ReduxFormMaterialSelect
                    required
                    name="isEdu"
                    className={cx(
                      "list-target",
                      "input-area",
                      "input-flex",
                      "select-input"
                    )}
                    fullWidth
                    menuList={[
                      {
                        key: 1,
                        value: 1,
                        text: defineMessages(
                          formatMessage({
                            id: "UserEdit_26",
                            defaultMessage: "사용",
                          })
                        ),
                      },
                      {
                        key: 0,
                        value: 0,
                        text: defineMessages(
                          formatMessage({
                            id: "UserEdit_15",
                            defaultMessage: "비활성",
                          })
                        ),
                      },
                    ]}
                    defaultValue={1}
                    checkType={101}
                    validate={["required"]}
                  />
                </div>
              </div>
            )}
            {/* 유예기간 기능이 아직 추가 안됨 */}
            {/* {commonVar.isGs !== 1 &&
              !addMode && (
                <ReduxFormMaterialSwitch
                  className={cx('input-switch')}
                  label={defineMessages(
                    formatMessage({
                      id: 'UserEdit_22',
                      defaultMessage: '비밀번호 갱신 알림 유예기간을 지금부터로 초기화'
                    })
                  )}
                  name="passwdNotifyDateNow"
                  checkType={101}
                />
              )} */}
          </div>
        )}
      </div>
    );
  }
}

UserEdit.propTypes = {
  //
  userInfo: PropTypes.object,
};
UserEdit.defaultProps = {
  //
  userInfo: {},
};

export default injectIntl(UserEdit);



// WEBPACK FOOTER //
// ./src/script/components/user/UserEdit.js